import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Country } from "types/country";

export interface CountryGroups {
  country: any;
  id: string;
  name: string;
  countries: Country[];
}

export const useCountryGroup = () => {
  const [countryGroups, setCountryGroups] = React.useState<CountryGroups[]>([]);
  const [fetching, setFetching] = React.useState(true);
  const [creating, setCreating] = React.useState(false);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => await getCountryGroups())();
  }, []);

  const getCountryGroups = async () => {
    try {
      setFetching(true);
      const response = await axios.get(
        `${API_BASE_URL}${API_URLS.CountryGroups}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      setCountryGroups(response.data.data);
    } catch (e) {
      console.error(e);
    } finally {
      setFetching(false);
    }
  };

  const createCountryGroup = async (name: string, ids: string[]) => {
    try {
      setCreating(true);
      await axios.post(
        `${API_BASE_URL}${API_URLS.CountryGroups}`,
        { name, country_ids: ids },
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      await getCountryGroups();
    } catch (e) {
      console.error(e);
    } finally {
      setCreating(false);
    }
  };

  const removeCountryGroup = async (id: string) => {
    try {
      setCreating(true);
      await axios.delete(
        `${API_BASE_URL}${API_URLS.CountryGroups}/${id}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      await getCountryGroups();
    } catch (e) {
      console.error(e);
    } finally {
      setCreating(false);
    }
  };

  const updateCountryGroup = async (id: string, name: string, countryIds: string[]) => {
    try {
      setCreating(true);
      await axios.put(
        `${API_BASE_URL}${API_URLS.CountryGroups}/${id}`,
        name ? { 
          name,          
          country_ids: countryIds, 
        } : { 
                  
          country_ids: countryIds, 
        },
        {
          headers: { Accept: 'application/json', Authorization: `Bearer ${token}` }
        }
      );
      await getCountryGroups();
    } catch (e) {
      console.error(e);
    } finally {
      setCreating(false);
    }
  
  
  };
  


  return { countryGroups, createCountryGroup, removeCountryGroup, fetching, creating, updateCountryGroup };
};
